import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const Language = ["en", "th"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "en", // default language
    debug: false, // true false
    whitelist: Language,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: "./locales/{{lng}}/{{ns}}.json",
      addPath: "./locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
